import { gql } from "@/gql/__generated__";
import { AppSubscriptionsFragment } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

export const INBOUND_SUBSCRIPTIONS = gql(`
    query InboundSubscriptions($organizationSlug: String!) {
        organization(organizationSlug: $organizationSlug ) {
            ... on Organization {
                __typename
                id
                apps {
                    __typename
                    subscription {
                        ... on AppSubscription { ... AppSubscriptions }
                    }
                }
            }
        }
    }
`);

type Props = { organizationSlug?: string };

export const useInboundSubscriptions = ({ organizationSlug = "" }: Props) => {
  const [subscriptions, setSubscriptions] = useState<
    AppSubscriptionsFragment[]
  >([]);
  const { data, ...rest } = useQuery(INBOUND_SUBSCRIPTIONS, {
    variables: { organizationSlug },
    skip: organizationSlug === ""
  });

  useEffect(() => {
    if (data?.organization.__typename !== "Organization") return;

    const appsWithSubscription = data.organization.apps.filter(
      (app) => app.subscription?.__typename === "AppSubscription"
    );
    setSubscriptions(
      appsWithSubscription.map(
        (app) => app.subscription as AppSubscriptionsFragment
      )
    );
  }, [organizationSlug, data]);

  return { ...rest, data: subscriptions };
};
